<template>
  <div class="regionManager" v-if="auth.list">
    <el-row :gutter="2">
      <el-col :xs="10">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-button type="primary" @click="addNew">新增</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="provinceList" style="width: 100%;" :fit="true"
                  :header-cell-style="{'text-align':'center'}"
                  highlight-current-row @current-change="handleProvinceCurrentChange"
                  ref="tableDom"
                  border
                  row-key="id"
                  lazy
                  :load="loadNextNode"
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="code" label="编码" sortable resizable :show-overflow-tooltip="true"
                           align="center"/>
          <el-table-column prop="name" label="名称" sortable resizable :show-overflow-tooltip="true"
                           align="center"/>
          <el-table-column prop="zipCode" label="邮编" sortable resizable :show-overflow-tooltip="true"
                           align="center"/>
          <el-table-column prop="isOpen" label="是否启用" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.isOpen === 1 ? 'success' : 'danger'"
                disable-transitions>{{scope.row.isOpen === 1?"是":"否"}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" min-width="150" label="操作" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-button type="" size="mini" @click="rowAddNew(scope.row,scope.$index)">新增</el-button>
              <el-button v-show="scope.row.isOpen==1" size="mini"
                         @click="isEnabled(scope.row,scope.$index,0)" type="danger">停止
              </el-button>
              <el-button v-show="scope.row.isOpen==0" size="mini"
                         @click="isEnabled(scope.row,scope.$index,1)" type="success">启用
              </el-button>
              <el-button type='primary' @click="editRegion(scope.row,scope.$index)" size="mini">编辑</el-button>
              <el-button type='danger' @click="removeRegion(scope.row,scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="ss" :visible.sync="dialogFormVisible" center>
      <template slot="title">
        <span class="el-dialog__title">{{dialogTitle}}</span>
      </template>
      <el-form :model="regionInfo" style="margin-left: 15%;margin-right:15%" :label-position="position"
               :hide-required-asterisk="false" label-width="auto"
               size="small"
               center>
        <el-form-item v-show="showInput" label="上级">
          <el-input v-model="regionInfo.parentName" disabled/>
        </el-form-item>
        <el-form-item required label="编码">
          <el-input type="number" clearable v-model='regionInfo.code' :disabled="disabledInput"></el-input>
        </el-form-item>
        <el-form-item required label="名称">
          <el-input clearable v-model='regionInfo.name'></el-input>
        </el-form-item>
        <el-form-item label="邮编">
          <el-input clearable v-model='regionInfo.zipCode'></el-input>
        </el-form-item>
        <el-form-item required label="是否启用">
          <el-switch
            v-model="isStatusOpen"
            style="width: 100%"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 20%;" @click="insertSubmit()" type="primary">提交</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import {getRegionTree, insertRegion, isOpenRegion, removeRegion, updateRegion} from '../../api/system'
  import {getPermission} from '../../api/authRequest'
  import {hideLoading, showLoading} from "../../components/loading/loading";

  export default {
    data() {
      return {
        auth: {
          list: true,
        },
        provinceList: [],
        cityList: [],
        regionList: [],
        loadNodeMap: new Map(),
        idArr: [],
        level: '',
        parentId: "",
        dialogFormVisible: false,
        dialogTitle: "",
        regionInfo: {},
        position: 'left',
        disabledInput: false,
        showInput: false,
        oldRowKey: '',
        open: 0,
        isUpdate: 0,
        isStatusOpen:false,
      }
    },
    mounted() {
      this.auth.list = getPermission("/system_region/query_sys_region");
      this.level = 1;
      this.parentId = 0;
      this.getProvinceList();
    },
    methods: {
      //获取省份地区
      getProvinceList() {
        let _self = this;
        let param = {
          level: this.level,
          parentId: this.parentId
        };
        getRegionTree(param).then(response => {
          if (response.data.status == 100) {
            _self.provinceList = response.data.results;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //树形节点
      loadNextNode(tree, treeNode, resolve) {
        let id = tree.id;
        this.level = null;
        this.loadNodeMap.set(id, {tree, treeNode, resolve});
        let param = {
          level: this.level,
          parentId: id,
        };
        getRegionTree(param).then(response => {
          if (response.data.status == 100) {
            resolve(response.data.results);
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //省选中
      handleProvinceCurrentChange(currentRow, oldCurrentRow) {
        this.currentRow = currentRow;
        this.currentRow.hasChildren = true;
        this.oldRowKey = oldCurrentRow == undefined ? '' : oldCurrentRow.id;
      },
      //省份新增
      addNew() {
        let _self = this;
        _self.disabledInput = false;
        _self.regionInfo = {};
        _self.regionInfo.parentId = 0;
        _self.regionInfo.parentName = "";
        _self.regionInfo.level = 1;
        _self.dialogFormVisible = true;
        _self.dialogTitle = "新增地区";
        _self.showInput = false;
        _self.isUpdate = 0;
      },
      //除省份追加
      rowAddNew(row, index) {
        let _self = this;
        console.info(row);
        _self.regionInfo = {};
        _self.regionInfo.parentId = row.id;
        _self.regionInfo.parentName = row.name;
        _self.regionInfo.level = row.level + 1;
        _self.dialogFormVisible = true;
        _self.dialogTitle = "新增地区";
        _self.disabledInput = false;
        _self.showInput = true;
        _self.isUpdate = 0;
      },
      //弹出框提交
      insertSubmit() {
        let _self = this;
        let name = _self.regionInfo.name;
        let code = _self.regionInfo.code;
        if (!name) {
          this.$Message.error("名称不允许为空");
          return;
        }
        if (!code) {
          this.$Message.error("编码不允许为空");
          return;
        }
        _self.regionInfo.isOpen = _self.isStatusOpen ? 1 : 0;
        showLoading();
        if (_self.isUpdate == 1) {
          _self.update();
        } else {
          _self.insert();
        }
      },
      //新增
      insert() {
        let _self = this;
        let params = {
          parentId: _self.regionInfo.parentId,
          name: _self.regionInfo.name,
          level: _self.regionInfo.level,
          code: _self.regionInfo.code,
          zipCode: _self.regionInfo.zipCode,
          isDelete: _self.regionInfo.isDelete,
          isOpen: _self.isStatusOpen?1:0,
        };
        insertRegion(params).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            _self.dialogFormVisible = false;
            if (_self.regionInfo.parentId == 0) {
              _self.getProvinceList();
            } else {
              const {tree, treeNode, resolve} = _self.loadNodeMap.get(_self.regionInfo.parentId);
              _self.loadNextNode(tree, treeNode, resolve);
            }
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //删除
      removeRegion(row, index) {
        let _self = this;
        _self.regionInfo = {};
        _self.regionInfo = row;
        _self.$confirm("是否删除", "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          showLoading();
          _self.remove();
        }).catch(() => {

        });

      },
      remove() {
        let _self = this;
        let param = {
          id: _self.regionInfo.id
        };
        removeRegion(param).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            if (_self.regionInfo.parentId == 0) {
              _self.getProvinceList();
            } else {
              this.$set(this.$refs.tableDom.store.states.lazyTreeNodeMap, _self.regionInfo.parentId, []);
              const {tree, treeNode, resolve} = this.loadNodeMap.get(_self.regionInfo.parentId);
              _self.loadNextNode(tree, treeNode, resolve);
            }
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //是否启用
      isEnabled(row, index, isEnabled) {
        let _self = this;
        _self.regionInfo = {};
        _self.regionInfo = row;
        _self.open = isEnabled;
        // _self.isOpen();
        let title = "是否启用";
        if (isEnabled != 1) {
          title = "是否禁用"
        }
        _self.$confirm(title, "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          showLoading();
          _self.isOpen();
        }).catch(() => {

        });
      },
      isOpen() {
        let _self = this;
        let params = {
          id: _self.regionInfo.id,
          isEnabled: _self.open
        };
        isOpenRegion(params).then(response => {
          hideLoading();
          _self.regionInfo.isOpen = _self.open;
          if (response.data.status == 100) {
            if (_self.regionInfo.parentId == 0) {
              _self.getProvinceList();
            } else {
              this.$set(this.$refs.tableDom.store.states.lazyTreeNodeMap, _self.regionInfo.id, []);
              const {tree, treeNode, resolve} = this.loadNodeMap.get(_self.regionInfo.id);
              _self.loadNextNode(tree, treeNode, resolve);
            }
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //编辑
      editRegion(row, index) {
        let _self = this;
        _self.regionInfo = row;
        _self.isStatusOpen = row.isOpen == 1;
        _self.dialogFormVisible = true;
        _self.disabledInput = true;
        _self.showInput = false;
        _self.isUpdate = 1;
      },
      update() {
        let _self = this;
        let params = {
          id: _self.regionInfo.id,
          name: _self.regionInfo.name,
          zipCode: _self.regionInfo.zipCode,
          isOpen: _self.isStatusOpen ? 1 : 0
        };
        updateRegion(params).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            _self.dialogFormVisible = false;
            if (_self.regionInfo.parentId == 0) {
              _self.getProvinceList();
            } else {
              this.$set(this.$refs.tableDom.store.states.lazyTreeNodeMap, _self.regionInfo.id, []);
              const {tree, treeNode, resolve} = this.loadNodeMap.get(_self.regionInfo.id);
              _self.loadNextNode(tree, treeNode, resolve);
            }
          } else {
            _self.regionInfo = _self.regionInfo.isOpen == 1 ? 0 : 1;
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          _self.regionInfo = _self.regionInfo.isOpen == 1 ? 0 : 1;
          this.$Message.error(error.message);
        })
      }
    },

  }
</script>
<style lang="scss" scoped>
  .schedulingList {
    .box-card {
      margin-bottom: 20px;
      border-radius: 0px;

      .card-header {
        font-size: 14px;
        line-height: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// regionManagerList.vue?73089dd3